import { Component } from '@angular/core';
import { CardMapComponent } from 'app/components/card-map/card-map.component';

@Component({
  selector: 'app-page-dashboard-map',
  templateUrl: './page-dashboard-map.component.html',
  styleUrls: ['./page-dashboard-map.component.scss'],
  imports: [CardMapComponent],
})
export class PageDashboardMapComponent {}
